// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Fxsu2","link":"Footer_link__9QdXq","rights":"Footer_rights__2xxwT"};